import { DrawerFormSection } from '../../../../common/components';
import { InvoicePreview } from '../SupplierLedgerShared';

const SupplierInvoicePreviewSection = ({
  amountLines,
  amountTotals,
  currentAttachmentName,
  file,
  form,
  providerName,
}) => (
  <DrawerFormSection title="Detalle" grid={false}>
    <InvoicePreview
      form={form}
      providerName={providerName}
      file={file}
      currentFileName={currentAttachmentName}
      amountLines={amountLines}
      amountTotals={amountTotals}
    />
  </DrawerFormSection>
);

export default SupplierInvoicePreviewSection;
